module.exports = __webpack_public_path__ + "img/zongbuchoupan.b967b334.png";